<app-modal title="SLA Diretos" [form]="form" [hideDefaultActions]="true">
  <form [formGroup]="form">
    <div class="tds-row">
      <app-input
        label="Senha"
        formControlName="senha"
        [readOnly]="true"
      ></app-input>
      <app-input
        label="Data Entrada"
        formControlName="dataEntrada"
        [readOnly]="true"
      ></app-input>
      <app-input label="Fornecedor" formControlName="fornecedor"></app-input>
    </div>

    <div class="tds-row">
      <app-input label="Registro" formControlName="registro"></app-input>
      <app-input
        label="Quantidade Linhas"
        formControlName="quantidadeLinhas"
      ></app-input>
      <app-input label="Observação" formControlName="observacao"></app-input>
    </div>

    <div class="tds-row">
      <app-input label="Nota Fiscal" formControlName="notaFiscal"></app-input>
      <app-input label="Volume" formControlName="volume"></app-input>
      <app-select
        label="Direcionamento"
        [options]="direcionamentoOptions"
        formControlName="direcionamento"
      ></app-select>
    </div>

    <div class="tds-row tds-u-justify-around">
      <tds-checkbox formControlName="critico" checkboxId="critico-checkbox">
        <div slot="label">Crítico</div>
      </tds-checkbox>
      <tds-checkbox formControlName="milkrun" checkboxId="milkrun-checkbox">
        <div slot="label">Milkrun</div>
      </tds-checkbox>
      <tds-checkbox
        formControlName="controlCenter"
        checkboxId="controlcenter-checkbox"
      >
        <div slot="label">Control Center</div>
      </tds-checkbox>
    </div>

    <div class="tds-row tds-u-justify-around tds-u-mt1">
      <app-button
        text="Dar Baixa"
        (clicked)="processar(fase.DAR_BAIXA)"
      ></app-button>
      <tds-button
        text="Cancelar"
        (click)="onClose()"
        variant="secondary"
      ></tds-button>
    </div>
  </form>
</app-modal>
